<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p4_fordow-box">
  <!-- Artboard: xs -->
  <div
    id="g-p4_fordow-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.70212765957447;"
  >
    <div
      id="g-p4_fordow-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_fordow-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.7655%;margin-top:-7.5px;left:47.7459%;width:59px;"
    >
      <p class="g-pstyle0">Fordow</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.2336%;margin-top:-7.5px;left:51.6443%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs"
      style="top:26.5957%;left:1.8817%;width:71.2121%;"
    >
      <p>
        The Institute for Science and International Security estimates that the
        underground facilities at <span class="g-cstyle0"
          >Fordow lie between 80 and 100 metres below the surface.</span
        >
      </p>
    </div>
    <div
      id="g-ai0-4"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:54.2726%;margin-top:-20.1px;left:81.7678%;margin-left:-56px;width:112px;"
    >
      <p class="g-pstyle2">Fordow</p>
      <p class="g-pstyle2">underground</p>
      <p class="g-pstyle2">nuclear facility</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:54.1662%;margin-top:-16.6px;left:2.5399%;width:109px;"
    >
      <p class="g-pstyle3">Mountain peak</p>
      <p class="g-pstyle3">960 metres</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:86.0722%;margin-top:-8.5px;left:59.9283%;width:115px;"
    >
      <p class="g-pstyle4">Tunnels entrance</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:86.9321%;margin-top:-8.6px;left:2.54%;width:98px;"
    >
      <p class="g-pstyle5">80 to 100 m.</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p4_fordow-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.92727272727273;"
  >
    <div
      id="g-p4_fordow-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_fordow-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.636%;margin-top:-7.5px;left:48.5414%;width:59px;"
    >
      <p class="g-pstyle0">Fordow</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.4542%;margin-top:-7.5px;left:51.064%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs"
      style="top:13.4545%;left:0.8056%;width:40.9804%;"
    >
      <p>
        The Institute for Science and International Security estimates that the
        underground facilities at <span class="g-cstyle0"
          >Fordow lie between 80 and 100 metres below the surface.</span
        >
      </p>
    </div>
    <div
      id="g-ai1-4"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:39.3934%;margin-top:-16.7px;left:79.5727%;margin-left:-84px;width:168px;"
    >
      <p class="g-pstyle2">Fordow underground</p>
      <p class="g-pstyle2">nuclear facility</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:42.6586%;margin-top:-18.6px;left:0.9864%;width:116px;"
    >
      <p class="g-pstyle3">Mountain peak</p>
      <p class="g-pstyle3">960 metres</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.3934%;margin-top:-9.7px;left:0.9864%;width:109px;"
    >
      <p class="g-pstyle4">80 to 100 m.</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:82.9136%;margin-top:-11px;left:55.4507%;width:154px;"
    >
      <p class="g-pstyle5">Tunnels entrance</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p4_fordow-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.29411764705882;"
  >
    <div
      id="g-p4_fordow-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_fordow-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs"
      style="top:7.451%;left:1.4746%;width:35.6061%;"
    >
      <p>
        The Institute for Science and International Security estimates that the
        underground facilities at <span class="g-cstyle0"
          >Fordow lie between 80 and 100 metres below the surface.</span
        >
      </p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.3133%;margin-top:-7.5px;left:47.2621%;width:60px;"
    >
      <p class="g-pstyle0">Fordow</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.431%;margin-top:-7.5px;left:49.2114%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:35.6285%;margin-top:-18.7px;left:70.5235%;margin-left:-89px;width:178px;"
    >
      <p class="g-pstyle2">Fordow underground</p>
      <p class="g-pstyle2">nuclear facility</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.377%;margin-top:-18.6px;left:1.4746%;width:116px;"
    >
      <p class="g-pstyle3">Mountain peak</p>
      <p class="g-pstyle3">960 metres</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:71.7695%;margin-top:-11px;left:57.2399%;width:154px;"
    >
      <p class="g-pstyle4">Tunnels entrance</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.9929%;margin-top:-9.7px;left:1.4746%;width:109px;"
    >
      <p class="g-pstyle5">80 to 100 m.</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-p4_fordow-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.75471698113208;"
  >
    <div
      id="g-p4_fordow-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_fordow-lg.jpg);"
    ></div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.5091%;margin-top:-7.5px;left:48.9224%;width:60px;"
    >
      <p class="g-pstyle0">Fordow</p>
    </div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs"
      style="top:7.3585%;left:14.4208%;width:25.2688%;"
    >
      <p>
        The Institute for Science and International Security estimates that the
        underground facilities at <span class="g-cstyle0"
          >Fordow lie between 80 and 100 metres below the surface.</span
        >
      </p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:10.4713%;margin-top:-7.5px;left:50.3058%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai4-4"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:31.8469%;margin-top:-18.8px;left:65.4141%;margin-left:-98px;width:196px;"
    >
      <p class="g-pstyle2">Fordow underground</p>
      <p class="g-pstyle2">nuclear facility</p>
    </div>
    <div
      id="g-ai4-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:40.1175%;margin-top:-18.6px;left:2.855%;width:116px;"
    >
      <p class="g-pstyle3">Mountain peak</p>
      <p class="g-pstyle3">960 metres</p>
    </div>
    <div
      id="g-ai4-6"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:66.6084%;margin-top:-11px;left:56.0034%;width:154px;"
    >
      <p class="g-pstyle4">Tunnels entrance</p>
    </div>
    <div
      id="g-ai4-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:78.0498%;margin-top:-9.7px;left:3.4443%;width:109px;"
    >
      <p class="g-pstyle5">80 to 100 m.</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-20 15:33 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-20 15:33 -->
<!-- ai file: p4_fordow.ai -->
<style lang="scss">
  #g-p4_fordow-box,
  #g-p4_fordow-box .g-artboard {
    margin: 0 auto;
  }
  #g-p4_fordow-box p {
    margin: 0;
  }
  #g-p4_fordow-box .g-aiAbs {
    position: absolute;
  }
  #g-p4_fordow-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p4_fordow-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p4_fordow-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p4_fordow-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p4_fordow-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-p4_fordow-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-p4_fordow-lg {
        display: block !important;
      }
    }
  }
  #g-p4_fordow-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p4_fordow-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_fordow-xs .g-pstyle0 {
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p4_fordow-xs .g-pstyle1 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p4_fordow-xs .g-pstyle2 {
    font-weight: 700;
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p4_fordow-xs .g-pstyle3 {
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    color: rgb(116, 116, 116);
  }
  #g-p4_fordow-xs .g-pstyle4 {
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    color: rgb(255, 255, 255);
  }
  #g-p4_fordow-xs .g-pstyle5 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    color: rgb(165, 15, 21);
  }
  #g-p4_fordow-xs .g-cstyle0 {
    font-weight: 700;
    color: rgb(165, 15, 21);
  }
  #g-p4_fordow-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p4_fordow-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_fordow-sm .g-pstyle0 {
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p4_fordow-sm .g-pstyle1 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p4_fordow-sm .g-pstyle2 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p4_fordow-sm .g-pstyle3 {
    line-height: 18px;
    height: 18px;
    color: rgb(116, 116, 116);
  }
  #g-p4_fordow-sm .g-pstyle4 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 16px;
    color: rgb(165, 15, 21);
  }
  #g-p4_fordow-sm .g-pstyle5 {
    line-height: 21px;
    height: 21px;
    font-size: 19px;
    color: rgb(255, 255, 255);
  }
  #g-p4_fordow-sm .g-cstyle0 {
    font-weight: 700;
    color: rgb(165, 15, 21);
  }
  #g-p4_fordow-md {
    position: relative;
    overflow: hidden;
  }
  #g-p4_fordow-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_fordow-md .g-pstyle0 {
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p4_fordow-md .g-pstyle1 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p4_fordow-md .g-pstyle2 {
    font-weight: 700;
    height: 18px;
    font-size: 17px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p4_fordow-md .g-pstyle3 {
    height: 18px;
    font-size: 15px;
    color: rgb(116, 116, 116);
  }
  #g-p4_fordow-md .g-pstyle4 {
    line-height: 21px;
    height: 21px;
    font-size: 19px;
    color: rgb(255, 255, 255);
  }
  #g-p4_fordow-md .g-pstyle5 {
    font-weight: 700;
    height: 18px;
    color: rgb(165, 15, 21);
  }
  #g-p4_fordow-md .g-cstyle0 {
    font-weight: 700;
    color: rgb(165, 15, 21);
  }
  #g-p4_fordow-lg {
    position: relative;
    overflow: hidden;
  }
  #g-p4_fordow-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_fordow-lg .g-pstyle0 {
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p4_fordow-lg .g-pstyle1 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p4_fordow-lg .g-pstyle2 {
    font-weight: 700;
    height: 18px;
    font-size: 19px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p4_fordow-lg .g-pstyle3 {
    height: 18px;
    font-size: 15px;
    color: rgb(116, 116, 116);
  }
  #g-p4_fordow-lg .g-pstyle4 {
    line-height: 21px;
    height: 21px;
    font-size: 19px;
    color: rgb(255, 255, 255);
  }
  #g-p4_fordow-lg .g-pstyle5 {
    font-weight: 700;
    height: 18px;
    color: rgb(165, 15, 21);
  }
  #g-p4_fordow-lg .g-cstyle0 {
    font-weight: 700;
    color: rgb(165, 15, 21);
  }

  /* Custom CSS */
  .g-shadow {
    text-shadow:
      1px 1px 1px rgb(0 0 0 / 90%),
      1px -1px 1px rgb(0 0 0 / 90%),
      -1px 1px 1px rgb(0 0 0 / 90%),
      -1px -1px 1px rgb(0 0 0 / 90%);
  }
</style>
